module.exports = __webpack_public_path__ + "img/icon-back.801d83ca.svg";